import axios from "axios";
import { spdrUrls } from "../../../../URL/ApplicationUrls";

export async function getSpdrShipFrequency(spdrId: number | undefined) {
  const response = await axios.get(spdrUrls.shipFrequencyApiUrl(spdrId));
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  const json = await response.data;
  if (!json) {
    throw new Error(`Receive Response, but got Error`);
  }

  return json.ShipFrequency as number;
}
